export default __webpack_public_path__ + "static/media/infy.2a518b9e.svg";